module.exports = __webpack_public_path__ + "static/media/dashboard.4dd71677.svg";